import React from 'react'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import Typography from '@material-ui/core/Typography'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import { makeStyles } from '@material-ui/core/styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const styles = makeStyles(theme => ({
  expand: {
    width: 20,
    height: 20,
  },
  title: {
    color: theme.palette.dark,
  },
  panelRoot: {
    boxShadow: `none`,
  },
  internalPanel: {
    paddingBottom: 0,
  },
}))

export default function Expansible({
  disabled = false,
  title,
  expanded,
  children,
  hidden = false,
  internal,
}) {
  const classes = styles()
  if (!hidden) {
    return (
      <Accordion
        square
        disabled={disabled}
        defaultExpanded={expanded}
        className={internal && classes.panelRoot}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon className={classes.expand} />}>
          <Typography variant="h3" className={classes.title}>
            {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={internal && classes.internalPanel}>
          {children}
        </AccordionDetails>
      </Accordion>
    )
  }
  return null
}
